import type { EasingFunction } from 'svelte/transition';

import { sineOut } from 'svelte/easing';

export class EventType {
  static readonly SCHEDULE = 'schedule';
  static readonly WEB_CHANNEL = 'webchannel';
  static readonly EVENT = 'event';
  static readonly LIBRARY = 'library';
  static readonly PLAYLIST = 'playlist';
}

type EventTypeKeys = Exclude<keyof typeof EventType, 'prototype'>;
export type EVENT_TYPE = (typeof EventType)[EventTypeKeys];
export const isEventTypePredicate = (type: Nullish<string>): type is EVENT_TYPE =>
  Object.values(EventType).includes(type);

export const toggleButtonFadeParams: Readonly<EasingFunction> = { duration: 500, easing: sineOut };
export const NO_CONTENT_VIDEO_ID = '3032a38b-cec7-4200-b4f5-c5412b4896b1';
